var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container container-vertical container-vertical-centered",staticStyle:{"width":"80%","padding":"4rem 0"}},[_c('h2',[_vm._v(_vm._s(_vm.titulo))]),_c('br'),_c(_vm.currentComponent,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }